import { apiClient } from '@/lib/api-client';
import { API_ENDPOINTS, Contact, ContactCreateUpdateRequest, PaginatedContactList, ContactLimits } from '@/types/api';

export const contactsApi = {
  // List all contacts
  list: async (params?: {
    page?: number;
    page_size?: number;
    search?: string;
    ordering?: string;
  }): Promise<PaginatedContactList> => {
    return apiClient.get<PaginatedContactList>(API_ENDPOINTS.contacts.list, params);
  },

  // Create a new contact
  create: async (data: ContactCreateUpdateRequest): Promise<Contact> => {
    return apiClient.post<Contact>(API_ENDPOINTS.contacts.list, data);
  },

  // Get a specific contact
  get: async (id: number): Promise<Contact> => {
    return apiClient.get<Contact>(API_ENDPOINTS.contacts.detail(id));
  },

  // Update a contact
  update: async (id: number, data: ContactCreateUpdateRequest): Promise<Contact> => {
    return apiClient.put<Contact>(API_ENDPOINTS.contacts.detail(id), data);
  },

  // Partially update a contact
  partialUpdate: async (id: number, data: Partial<ContactCreateUpdateRequest>): Promise<Contact> => {
    return apiClient.patch<Contact>(API_ENDPOINTS.contacts.detail(id), data);
  },

  // Delete a contact
  delete: async (id: number): Promise<void> => {
    return apiClient.delete(API_ENDPOINTS.contacts.detail(id));
  },

  // Get contacts with upcoming birthdays
  getBirthdays: async (days?: number): Promise<Contact[]> => {
    const params = days ? { days } : undefined;
    return apiClient.get<Contact[]>(API_ENDPOINTS.contacts.birthdays, params);
  },

  // Filter contacts by relationship type
  getByRelationship: async (type: string): Promise<Contact[]> => {
    return apiClient.get<Contact[]>(API_ENDPOINTS.contacts.byRelationship, { type });
  },

  // Get all available relationship types
  getRelationshipTypes: async (): Promise<any> => {
    return apiClient.get(API_ENDPOINTS.contacts.relationshipTypes);
  },

  // Advanced search
  search: async (query: string): Promise<Contact[]> => {
    return apiClient.get<Contact[]>(API_ENDPOINTS.contacts.search, { q: query });
  },

  // Get contact limits for the user
  getLimits: async (): Promise<ContactLimits> => {
    return apiClient.get<ContactLimits>(API_ENDPOINTS.contacts.limits);
  },
};